import { render, staticRenderFns } from "./Prescription.vue?vue&type=template&id=c8db9658&scoped=true&"
import script from "./Prescription.vue?vue&type=script&lang=js&"
export * from "./Prescription.vue?vue&type=script&lang=js&"
import style0 from "./Prescription.vue?vue&type=style&index=0&id=c8db9658&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8db9658",
  null
  
)

export default component.exports